import React, {ReactElement} from "react";

import MarkdownText, {
  MARKDOWN_TYPES,
} from "../../markdown/markdown-text/MarkdownText";

import {css} from "/src/utils/utils";

import * as styles from "./widget-markdown.module.scss";

interface WidgetMarkdownProps {
  text: string;
}

const WidgetMarkdown = (props: WidgetMarkdownProps): ReactElement => {
  const {text} = props;

  return (
    <section className={css("widget-base", styles.widgetMarkdown)}>
      <MarkdownText text={text} type={MARKDOWN_TYPES.ARTICLE} />
    </section>
  );
};

export default WidgetMarkdown;
